import "@aileron/button-icon";
import { unsafeCSS as yt, LitElement as Ft, html as ft } from "lit";
import { query as Dt, property as K, queryAsync as Mt } from "lit/decorators.js";
import { classMap as X } from "lit/directives/class-map.js";
const Vt = (t) => {
  class e extends t {
    constructor(...n) {
      super(...n), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const i = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(i.getElementsByTagName("link")).findIndex(
        (a) => a.href === this.fontLink
      ) === -1) {
        const a = document.createElement("link");
        a.href = this.fontLink, a.rel = "stylesheet", document.head.appendChild(a);
      }
    }
  }
  return e;
}, Nt = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.static{position:static}.absolute{position:absolute}.z-\\[1\\]{z-index:1}.mb-0{margin-bottom:0}.ml-0{margin-left:0}.mr-\\[21px\\]{margin-right:21px}.mt-0{margin-top:0}.mt-0\\.5{margin-top:.125rem}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-2{height:.5rem}.h-2\\.5{height:.625rem}.w-2{width:.5rem}.w-2\\.5{width:.625rem}.w-auto{width:auto}.max-w-\\[290px\\]{max-width:290px}.justify-between{justify-content:space-between}.gap-4{gap:1rem}.self-center{align-self:center}.rounded{border-radius:.25rem}.bg-blue-060{background-color:#0860c4}.bg-neutral-140{background-color:#fff}.p-4{padding:1rem}.text-left{text-align:left}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.text-xl{font-size:1.25rem}.font-normal{font-weight:400}.leading-6{line-height:1.5rem}.text-neutral-010{color:#181e25}.text-neutral-140{color:#fff}.opacity-0{opacity:0}.opacity-100{opacity:1}.shadow-lg{--tw-shadow: 0px 5px 22px 4px rgba(0, 0, 0, .12), 0px 12px 17px 2px rgba(0, 0, 0, .14), 0px 7px 8px -4px rgba(0, 0, 0, .2);--tw-shadow-colored: 0px 5px 22px 4px var(--tw-shadow-color), 0px 12px 17px 2px var(--tw-shadow-color), 0px 7px 8px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}[hidden]{display:none!important}
`, _t = yt(Nt), Q = "aileron-color-scheme", dt = "aileron-color-scheme-change", $t = (t) => {
  class e extends t {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (n) => {
        n.detail ? this.setAttribute(Q, n.detail) : this.removeAttribute(Q);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        dt,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const n = document.documentElement.getAttribute(
        Q
      );
      n && this.setAttribute(Q, n);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        dt,
        this.handleSchemeSwitch
      );
    }
  }
  return e.styles = [
    _t,
    t.styles ?? []
  ], e;
}, vt = $t(Vt(Ft));
function it(t, e, o) {
  const n = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...o
  });
  return t.dispatchEvent(n), n;
}
function U(t) {
  return t.split("-")[1];
}
function at(t) {
  return t === "y" ? "height" : "width";
}
function M(t) {
  return t.split("-")[0];
}
function G(t) {
  return ["top", "bottom"].includes(M(t)) ? "x" : "y";
}
function ut(t, e, o) {
  let {
    reference: n,
    floating: i
  } = t;
  const r = n.x + n.width / 2 - i.width / 2, s = n.y + n.height / 2 - i.height / 2, a = G(e), c = at(a), l = n[c] / 2 - i[c] / 2, h = M(e), f = a === "x";
  let u;
  switch (h) {
    case "top":
      u = {
        x: r,
        y: n.y - i.height
      };
      break;
    case "bottom":
      u = {
        x: r,
        y: n.y + n.height
      };
      break;
    case "right":
      u = {
        x: n.x + n.width,
        y: s
      };
      break;
    case "left":
      u = {
        x: n.x - i.width,
        y: s
      };
      break;
    default:
      u = {
        x: n.x,
        y: n.y
      };
  }
  switch (U(e)) {
    case "start":
      u[a] -= l * (o && f ? -1 : 1);
      break;
    case "end":
      u[a] += l * (o && f ? -1 : 1);
      break;
  }
  return u;
}
const Bt = async (t, e, o) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = o, a = r.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: h,
    y: f
  } = ut(l, n, c), u = n, d = {}, p = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: w,
      fn: g
    } = a[m], {
      x,
      y,
      data: E,
      reset: b
    } = await g({
      x: h,
      y: f,
      initialPlacement: n,
      placement: u,
      strategy: i,
      middlewareData: d,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (h = x ?? h, f = y ?? f, d = {
      ...d,
      [w]: {
        ...d[w],
        ...E
      }
    }, b && p <= 50) {
      p++, typeof b == "object" && (b.placement && (u = b.placement), b.rects && (l = b.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: i
      }) : b.rects), {
        x: h,
        y: f
      } = ut(l, u, c)), m = -1;
      continue;
    }
  }
  return {
    x: h,
    y: f,
    placement: u,
    strategy: i,
    middlewareData: d
  };
};
function Ht(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function kt(t) {
  return typeof t != "number" ? Ht(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Z(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
async function Ct(t, e) {
  var o;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: r,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: f = "floating",
    altBoundary: u = !1,
    padding: d = 0
  } = e, p = kt(d), w = a[u ? f === "floating" ? "reference" : "floating" : f], g = Z(await r.getClippingRect({
    element: (o = await (r.isElement == null ? void 0 : r.isElement(w))) == null || o ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: h,
    strategy: c
  })), x = f === "floating" ? {
    ...s.floating,
    x: n,
    y: i
  } : s.reference, y = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), E = await (r.isElement == null ? void 0 : r.isElement(y)) ? await (r.getScale == null ? void 0 : r.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Z(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: x,
    offsetParent: y,
    strategy: c
  }) : x);
  return {
    top: (g.top - b.top + p.top) / E.y,
    bottom: (b.bottom - g.bottom + p.bottom) / E.y,
    left: (g.left - b.left + p.left) / E.x,
    right: (b.right - g.right + p.right) / E.x
  };
}
const Wt = Math.min, jt = Math.max;
function rt(t, e, o) {
  return jt(t, Wt(e, o));
}
const It = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      element: o,
      padding: n = 0
    } = t || {}, {
      x: i,
      y: r,
      placement: s,
      rects: a,
      platform: c,
      elements: l
    } = e;
    if (o == null)
      return {};
    const h = kt(n), f = {
      x: i,
      y: r
    }, u = G(s), d = at(u), p = await c.getDimensions(o), m = u === "y", w = m ? "top" : "left", g = m ? "bottom" : "right", x = m ? "clientHeight" : "clientWidth", y = a.reference[d] + a.reference[u] - f[u] - a.floating[d], E = f[u] - a.reference[u], b = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(o));
    let L = b ? b[x] : 0;
    (!L || !await (c.isElement == null ? void 0 : c.isElement(b))) && (L = l.floating[x] || a.floating[d]);
    const P = y / 2 - E / 2, F = h[w], W = L - p[d] - h[g], S = L / 2 - p[d] / 2 + P, R = rt(F, S, W), D = U(s) != null && S != R && a.reference[d] / 2 - (S < F ? h[w] : h[g]) - p[d] / 2 < 0 ? S < F ? F - S : W - S : 0;
    return {
      [u]: f[u] - D,
      data: {
        [u]: R,
        centerOffset: S - R
      }
    };
  }
}), Xt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function tt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Xt[e]);
}
function Yt(t, e, o) {
  o === void 0 && (o = !1);
  const n = U(t), i = G(t), r = at(i);
  let s = i === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = tt(s)), {
    main: s,
    cross: tt(s)
  };
}
const qt = {
  start: "end",
  end: "start"
};
function st(t) {
  return t.replace(/start|end/g, (e) => qt[e]);
}
function Kt(t) {
  const e = tt(t);
  return [st(t), e, st(e)];
}
function Ut(t, e, o) {
  const n = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return o ? e ? i : n : e ? n : i;
    case "left":
    case "right":
      return e ? r : s;
    default:
      return [];
  }
}
function Gt(t, e, o, n) {
  const i = U(t);
  let r = Ut(M(t), o === "start", n);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(st)))), r;
}
const Jt = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var o;
      const {
        placement: n,
        middlewareData: i,
        rects: r,
        initialPlacement: s,
        platform: a,
        elements: c
      } = e, {
        mainAxis: l = !0,
        crossAxis: h = !0,
        fallbackPlacements: f,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: d = "none",
        flipAlignment: p = !0,
        ...m
      } = t, w = M(n), g = M(s) === s, x = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), y = f || (g || !p ? [tt(s)] : Kt(s));
      !f && d !== "none" && y.push(...Gt(s, p, d, x));
      const E = [s, ...y], b = await Ct(e, m), L = [];
      let P = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (l && L.push(b[w]), h) {
        const {
          main: R,
          cross: j
        } = Yt(n, r, x);
        L.push(b[R], b[j]);
      }
      if (P = [...P, {
        placement: n,
        overflows: L
      }], !L.every((R) => R <= 0)) {
        var F, W;
        const R = (((F = i.flip) == null ? void 0 : F.index) || 0) + 1, j = E[R];
        if (j)
          return {
            data: {
              index: R,
              overflows: P
            },
            reset: {
              placement: j
            }
          };
        let D = (W = P.filter((_) => _.overflows[0] <= 0).sort((_, $) => _.overflows[1] - $.overflows[1])[0]) == null ? void 0 : W.placement;
        if (!D)
          switch (u) {
            case "bestFit": {
              var S;
              const _ = (S = P.map(($) => [$.placement, $.overflows.filter((I) => I > 0).reduce((I, Pt) => I + Pt, 0)]).sort(($, I) => $[1] - I[1])[0]) == null ? void 0 : S[0];
              _ && (D = _);
              break;
            }
            case "initialPlacement":
              D = s;
              break;
          }
        if (n !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
async function Qt(t, e) {
  const {
    placement: o,
    platform: n,
    elements: i
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), s = M(o), a = U(o), c = G(o) === "x", l = ["left", "top"].includes(s) ? -1 : 1, h = r && c ? -1 : 1, f = typeof e == "function" ? e(t) : e;
  let {
    mainAxis: u,
    crossAxis: d,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return a && typeof p == "number" && (d = a === "end" ? p * -1 : p), c ? {
    x: d * h,
    y: u * l
  } : {
    x: u * l,
    y: d * h
  };
}
const Zt = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: o,
        y: n
      } = e, i = await Qt(e, t);
      return {
        x: o + i.x,
        y: n + i.y,
        data: i
      };
    }
  };
};
function te(t) {
  return t === "x" ? "y" : "x";
}
const ee = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: o,
        y: n,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (w) => {
            let {
              x: g,
              y: x
            } = w;
            return {
              x: g,
              y: x
            };
          }
        },
        ...c
      } = t, l = {
        x: o,
        y: n
      }, h = await Ct(e, c), f = G(M(i)), u = te(f);
      let d = l[f], p = l[u];
      if (r) {
        const w = f === "y" ? "top" : "left", g = f === "y" ? "bottom" : "right", x = d + h[w], y = d - h[g];
        d = rt(x, d, y);
      }
      if (s) {
        const w = u === "y" ? "top" : "left", g = u === "y" ? "bottom" : "right", x = p + h[w], y = p - h[g];
        p = rt(x, p, y);
      }
      const m = a.fn({
        ...e,
        [f]: d,
        [u]: p
      });
      return {
        ...m,
        data: {
          x: m.x - o,
          y: m.y - n
        }
      };
    }
  };
};
function k(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function C(t) {
  return k(t).getComputedStyle(t);
}
function At(t) {
  return t instanceof k(t).Node;
}
function T(t) {
  return At(t) ? (t.nodeName || "").toLowerCase() : "";
}
function A(t) {
  return t instanceof k(t).HTMLElement;
}
function v(t) {
  return t instanceof k(t).Element;
}
function pt(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  const e = k(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function J(t) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: n,
    display: i
  } = C(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(i);
}
function ne(t) {
  return ["table", "td", "th"].includes(T(t));
}
function ct(t) {
  const e = lt(), o = C(t);
  return o.transform !== "none" || o.perspective !== "none" || !e && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !e && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function lt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function nt(t) {
  return ["html", "body", "#document"].includes(T(t));
}
const ht = Math.min, Y = Math.max, et = Math.round;
function Et(t) {
  const e = C(t);
  let o = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = A(t), r = i ? t.offsetWidth : o, s = i ? t.offsetHeight : n, a = et(o) !== r || et(n) !== s;
  return a && (o = r, n = s), {
    width: o,
    height: n,
    fallback: a
  };
}
function St(t) {
  return v(t) ? t : t.contextElement;
}
const Rt = {
  x: 1,
  y: 1
};
function B(t) {
  const e = St(t);
  if (!A(e))
    return Rt;
  const o = e.getBoundingClientRect(), {
    width: n,
    height: i,
    fallback: r
  } = Et(e);
  let s = (r ? et(o.width) : o.width) / n, a = (r ? et(o.height) : o.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const mt = {
  x: 0,
  y: 0
};
function Lt(t, e, o) {
  var n, i;
  if (e === void 0 && (e = !0), !lt())
    return mt;
  const r = t ? k(t) : window;
  return !o || e && o !== r ? mt : {
    x: ((n = r.visualViewport) == null ? void 0 : n.offsetLeft) || 0,
    y: ((i = r.visualViewport) == null ? void 0 : i.offsetTop) || 0
  };
}
function V(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), r = St(t);
  let s = Rt;
  e && (n ? v(n) && (s = B(n)) : s = B(t));
  const a = Lt(r, o, n);
  let c = (i.left + a.x) / s.x, l = (i.top + a.y) / s.y, h = i.width / s.x, f = i.height / s.y;
  if (r) {
    const u = k(r), d = n && v(n) ? k(n) : n;
    let p = u.frameElement;
    for (; p && n && d !== u; ) {
      const m = B(p), w = p.getBoundingClientRect(), g = getComputedStyle(p);
      w.x += (p.clientLeft + parseFloat(g.paddingLeft)) * m.x, w.y += (p.clientTop + parseFloat(g.paddingTop)) * m.y, c *= m.x, l *= m.y, h *= m.x, f *= m.y, c += w.x, l += w.y, p = k(p).frameElement;
    }
  }
  return Z({
    width: h,
    height: f,
    x: c,
    y: l
  });
}
function z(t) {
  return ((At(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function ot(t) {
  return v(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function oe(t) {
  let {
    rect: e,
    offsetParent: o,
    strategy: n
  } = t;
  const i = A(o), r = z(o);
  if (o === r)
    return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = {
    x: 1,
    y: 1
  };
  const c = {
    x: 0,
    y: 0
  };
  if ((i || !i && n !== "fixed") && ((T(o) !== "body" || J(r)) && (s = ot(o)), A(o))) {
    const l = V(o);
    a = B(o), c.x = l.x + o.clientLeft, c.y = l.y + o.clientTop;
  }
  return {
    width: e.width * a.x,
    height: e.height * a.y,
    x: e.x * a.x - s.scrollLeft * a.x + c.x,
    y: e.y * a.y - s.scrollTop * a.y + c.y
  };
}
function Ot(t) {
  return V(z(t)).left + ot(t).scrollLeft;
}
function ie(t) {
  const e = z(t), o = ot(t), n = t.ownerDocument.body, i = Y(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = Y(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -o.scrollLeft + Ot(t);
  const a = -o.scrollTop;
  return C(n).direction === "rtl" && (s += Y(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: a
  };
}
function H(t) {
  if (T(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    pt(t) && t.host || // Fallback.
    z(t)
  );
  return pt(e) ? e.host : e;
}
function Tt(t) {
  const e = H(t);
  return nt(e) ? e.ownerDocument.body : A(e) && J(e) ? e : Tt(e);
}
function q(t, e) {
  var o;
  e === void 0 && (e = []);
  const n = Tt(t), i = n === ((o = t.ownerDocument) == null ? void 0 : o.body), r = k(n);
  return i ? e.concat(r, r.visualViewport || [], J(n) ? n : []) : e.concat(n, q(n));
}
function re(t, e) {
  const o = k(t), n = z(t), i = o.visualViewport;
  let r = n.clientWidth, s = n.clientHeight, a = 0, c = 0;
  if (i) {
    r = i.width, s = i.height;
    const l = lt();
    (!l || l && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: a,
    y: c
  };
}
function se(t, e) {
  const o = V(t, !0, e === "fixed"), n = o.top + t.clientTop, i = o.left + t.clientLeft, r = A(t) ? B(t) : {
    x: 1,
    y: 1
  }, s = t.clientWidth * r.x, a = t.clientHeight * r.y, c = i * r.x, l = n * r.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function wt(t, e, o) {
  let n;
  if (e === "viewport")
    n = re(t, o);
  else if (e === "document")
    n = ie(z(t));
  else if (v(e))
    n = se(e, o);
  else {
    const i = Lt(t);
    n = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return Z(n);
}
function zt(t, e) {
  const o = H(t);
  return o === e || !v(o) || nt(o) ? !1 : C(o).position === "fixed" || zt(o, e);
}
function ae(t, e) {
  const o = e.get(t);
  if (o)
    return o;
  let n = q(t).filter((a) => v(a) && T(a) !== "body"), i = null;
  const r = C(t).position === "fixed";
  let s = r ? H(t) : t;
  for (; v(s) && !nt(s); ) {
    const a = C(s), c = ct(s);
    !c && a.position === "fixed" && (i = null), (r ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || J(s) && !c && zt(t, s)) ? n = n.filter((h) => h !== s) : i = a, s = H(s);
  }
  return e.set(t, n), n;
}
function ce(t) {
  let {
    element: e,
    boundary: o,
    rootBoundary: n,
    strategy: i
  } = t;
  const s = [...o === "clippingAncestors" ? ae(e, this._c) : [].concat(o), n], a = s[0], c = s.reduce((l, h) => {
    const f = wt(e, h, i);
    return l.top = Y(f.top, l.top), l.right = ht(f.right, l.right), l.bottom = ht(f.bottom, l.bottom), l.left = Y(f.left, l.left), l;
  }, wt(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function le(t) {
  return Et(t);
}
function gt(t, e) {
  return !A(t) || C(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function fe(t) {
  let e = H(t);
  for (; A(e) && !nt(e); ) {
    if (ct(e))
      return e;
    e = H(e);
  }
  return null;
}
function bt(t, e) {
  const o = k(t);
  if (!A(t))
    return o;
  let n = gt(t, e);
  for (; n && ne(n) && C(n).position === "static"; )
    n = gt(n, e);
  return n && (T(n) === "html" || T(n) === "body" && C(n).position === "static" && !ct(n)) ? o : n || fe(t) || o;
}
function de(t, e, o) {
  const n = A(e), i = z(e), r = o === "fixed", s = V(t, !0, r, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = {
    x: 0,
    y: 0
  };
  if (n || !n && !r)
    if ((T(e) !== "body" || J(i)) && (a = ot(e)), A(e)) {
      const l = V(e, !0, r, e);
      c.x = l.x + e.clientLeft, c.y = l.y + e.clientTop;
    } else
      i && (c.x = Ot(i));
  return {
    x: s.left + a.scrollLeft - c.x,
    y: s.top + a.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
const ue = {
  getClippingRect: ce,
  convertOffsetParentRelativeRectToViewportRelativeRect: oe,
  isElement: v,
  getDimensions: le,
  getOffsetParent: bt,
  getDocumentElement: z,
  getScale: B,
  async getElementRects(t) {
    let {
      reference: e,
      floating: o,
      strategy: n
    } = t;
    const i = this.getOffsetParent || bt, r = this.getDimensions;
    return {
      reference: de(e, await i(o), n),
      floating: {
        x: 0,
        y: 0,
        ...await r(o)
      }
    };
  },
  getClientRects: (t) => Array.from(t.getClientRects()),
  isRTL: (t) => C(t).direction === "rtl"
};
function pe(t, e, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = !0,
    animationFrame: a = !1
  } = n, c = i || r ? [...v(t) ? q(t) : t.contextElement ? q(t.contextElement) : [], ...q(e)] : [];
  c.forEach((d) => {
    const p = !v(d) && d.toString().includes("V");
    i && (!a || p) && d.addEventListener("scroll", o, {
      passive: !0
    }), r && d.addEventListener("resize", o);
  });
  let l = null;
  s && (l = new ResizeObserver(() => {
    o();
  }), v(t) && !a && l.observe(t), !v(t) && t.contextElement && !a && l.observe(t.contextElement), l.observe(e));
  let h, f = a ? V(t) : null;
  a && u();
  function u() {
    const d = V(t);
    f && (d.x !== f.x || d.y !== f.y || d.width !== f.width || d.height !== f.height) && o(), f = d, h = requestAnimationFrame(u);
  }
  return o(), () => {
    var d;
    c.forEach((p) => {
      i && p.removeEventListener("scroll", o), r && p.removeEventListener("resize", o);
    }), (d = l) == null || d.disconnect(), l = null, a && cancelAnimationFrame(h);
  };
}
const he = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: ue,
    ...o
  }, r = {
    ...i.platform,
    _c: n
  };
  return Bt(t, e, {
    ...i,
    platform: r
  });
};
class xt {
  constructor(e, o, n) {
    this.element = e, this.target = o, this.arrow = n;
  }
  activate(e) {
    pe(this.target, this.element, () => {
      he(this.target, this.element, {
        placement: e,
        middleware: [
          Zt(10),
          ee({ padding: 5 }),
          Jt(),
          It({ element: this.arrow })
          // autoPlacement({allowedPlacements: ['top', 'bottom']})
        ]
      }).then(
        ({
          x: o,
          y: n,
          placement: i,
          middlewareData: r
        }) => {
          this.element.style.left = `${o}px`, this.element.style.top = `${n}px`;
          const { x: s, y: a } = r.arrow, c = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[i.split("-")[0]];
          Object.assign(this.arrow.style, {
            left: s !== void 0 ? `${s}px` : "",
            top: a !== void 0 ? `${a}px` : "",
            right: "",
            bottom: "",
            [c]: "-4px"
          });
        }
      );
    });
  }
}
const me = `:host .adc-popover{transform:scale(.75);transition:opacity,transform;transition-duration:.33s}@media (max-width: 40em){:host .adc-popover{max-width:calc(100vw - 7.25rem)}}:host([showing]) .adc-popover{transform:scale(1)}:host .adc-popover #arrow{transform:rotate(45deg)}:host .close-btn--secondary::part(button-icon):focus{outline-color:#fff}:host .close-btn--secondary::part(button-icon){color:#e6eaef}
`;
var we = Object.defineProperty, ge = Object.getOwnPropertyDescriptor, N = (t, e, o, n) => {
  for (var i = n > 1 ? void 0 : n ? ge(e, o) : e, r = t.length - 1, s; r >= 0; r--)
    (s = t[r]) && (i = (n ? s(e, o, i) : s(i)) || i);
  return n && i && we(e, o, i), i;
};
class O extends vt {
  constructor() {
    super(), this.heading = "", this.showing = !0, this.closeLabelText = "Close Modal", this.kind = "primary", this._target = null, this.placement = "bottom", this.hide = () => {
      this.showing = !1, it(this, "adc-hide");
    }, this.finishHide = () => {
      this.showing || (this.style.display = "none", it(this, "adc-finish-hide"));
    }, this.addEventListener("adc-hide", this.finishHide);
  }
  async connectedCallback() {
    super.connectedCallback();
    const e = await this._arrow;
    this.target ??= this.previousElementSibling || null, this.float = new xt(this.popoverDiv, this._target, e), this.float.activate(this.placement), this.showing = !0, this.style.cssText = "";
  }
  render() {
    return ft`
      <div
        class="adc-popover inline-block absolute p-4 rounded opacity-0 w-auto gap-4 text-left z-[1] shadow-lg max-w-[290px] ${X(
      {
        "bg-neutral-140": this.kind === "primary",
        "opacity-100": this.showing,
        "bg-blue-060": this.kind === "secondary"
      }
    )}"
      >
        <div part="header-container" class="flex justify-between">
          ${this.heading && ft`<span
            id="header"
            part="header"
            class="font-sans font-normal text-xl leading-6 text-left mt-0.5 mr-[21px] mb-0 ml-0 text-neutral-010 flex self-center ${X(
      { "text-neutral-140": this.kind === "secondary" }
    )}"
            >${this.heading}</span
          >`}
          <adc-button-icon
            part="icon"
            class="close-btn ${X({
      "close-btn--secondary": this.kind === "secondary"
    })}"
            kind="ghost"
            size="sm"
            icon="action:close"
            outlined
            label-text="${this.closeLabelText}"
            @click=${this.handleClick}
          ></adc-button-icon>
        </div>
        <span
          part="content"
          class="font-sans font-normal text-base leading-6 text-left text-neutral-010 ${X(
      {
        "text-neutral-140": this.kind === "secondary"
      }
    )}"
        >
          <slot></slot>
        </span>
        <div
          part="arrow"
          id="arrow"
          class="absolute w-2.5 h-2.5 ${X({
      "bg-neutral-140": this.kind === "primary",
      "bg-blue-060": this.kind === "secondary"
    })}"
        ></div>
      </div>
    `;
  }
  /**
   * @private
   */
  get target() {
    return this._target;
  }
  /**
   * @private
   */
  set target(e) {
    this._target = e;
  }
  handleClick() {
    this.hide(), it(this, "adc-close-popover");
  }
  async updated(e) {
    const o = await this._arrow;
    this.target ??= this.previousElementSibling, (e.has("type") || e.has("toggle")) && (this.float = new xt(this.popoverDiv, this._target, o));
  }
}
O.styles = [vt.styles || [], yt(me)];
N([
  Dt(".adc-popover")
], O.prototype, "popoverDiv", 2);
N([
  K({ reflect: !0, type: String })
], O.prototype, "heading", 2);
N([
  K({ reflect: !0, type: Boolean })
], O.prototype, "showing", 2);
N([
  K({ reflect: !0, type: String, attribute: "close-label-text" })
], O.prototype, "closeLabelText", 2);
N([
  K({ reflect: !0 })
], O.prototype, "kind", 2);
N([
  Mt("#arrow")
], O.prototype, "_arrow", 2);
N([
  K({ reflect: !0 })
], O.prototype, "placement", 2);
try {
  customElements.define("adc-popover", O);
} catch {
}
export {
  O as Popover
};
